export default {"src":"/_next/static/media/hungerhub-logo-white.33a37584.svg","height":51,"width":140};